// import { fakeT, FakeTClass } from './fake-t';
// import { i18n } from '@/main';
// import router from '@app/router/index.APP_TARGET';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { bpcApi } from '@core/services/bpc-api.service';
import router from '@app/router/index.APP_TARGET';

const bpcRouterHelper = new BPCApiRouteHelper();

export class TranslationCSVService {
  getUserOS(): string {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  async downloadAllMessagesCSV() {
    const route = `${bpcRouterHelper.getTranslationsPath()}/generate-csv`;
    const queryConfig = {
      params: {
        os: this.getUserOS(),
      },
    };

    try {
      const res = await bpcApi
        .download(route, 'official-translations.csv', queryConfig)
        .toPromise();
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  async generateNewTranslationsFromCSV() {
    const route = `${bpcRouterHelper.getTranslationsPath()}/process-csv`;
    try {
      await bpcApi.post(route).toPromise();
      await router.go(null);
      return true;
    } catch (error) {
      console.log(error);
    }
  }
}
